import { CreateCatalogPayload } from '../../../modules/catalogs/creation/catalogCreation.types';
import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import { CreateCatalogOutput, FindCatalogsOutput } from './catalogs.repository.types';
import { CatalogListFilters } from './catalogsBulk.repository.types';

export const findCatalogs = (params?: CatalogListFilters, signal?: AbortSignal) =>
  restApi.get<FindCatalogsOutput>('catalogs', params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });

export const createCatalog = (payload: CreateCatalogPayload) =>
  restApi.post<CreateCatalogOutput>('catalogs', payload);
